module.exports = __webpack_public_path__ + "img/0 1.3816b3a5.png";